import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold mb-6 text-[#003366]">Privacy Policy</h1>

      <p className="mb-4">
        This Privacy Policy describes how National Property Consultant (NPC) collects, uses, and protects any information
        that you provide when using our website or submitting your details via our lead forms and digital tools.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">What We Collect</h2>
      <p className="mb-4">
        We may collect your name, email address, phone number, and basic information related to your investment goals
        or property preferences.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
      <p className="mb-4">
        We use this information to contact you for the purpose of providing property advice, booking strategy sessions,
        and offering relevant investment services.
      </p>
      <p className="mb-4">
        We will never sell your information to third parties. Your data is stored securely and only accessible to authorized
        members of our team.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Marketing Communication</h2>
      <p className="mb-4">
        By submitting your information, you agree to be contacted via phone, email, or SMS. You can unsubscribe at any time.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Security</h2>
      <p className="mb-4">
        We are committed to ensuring that your information is secure. We use appropriate procedures to protect and manage your data.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p className="mb-4">
        If you have any questions or would like your data removed, please contact us at{' '}
        <a href="mailto:info@nationalpropertyconsultant.com.au" className="text-blue-600 underline">
          info@nationalpropertyconsultant.com.au
        </a>.
      </p>

      <p className="text-sm text-gray-600 mt-6">Last updated: {new Date().toLocaleDateString()}</p>
    </div>
  );
};

export default PrivacyPolicy;
